import axios from 'axios'

import { COMPAREPRICE as ENDPOINT } from '../common/endpoints'
import { success, error } from '../main/toast-notifications'
import { t } from '../main/i18n'
import { createLightbox, /*updateContent*/ } from '../main/lightbox'

const targetClass = '.j-lightbox__price'
const targetBtn = document.querySelector('.j-open--price')
const lightbox = document.querySelector(targetClass)
const priceForm = lightbox.querySelector('form')
let lightboxInstance

const bindEvents = (priceForm) => {
	priceForm.addEventListener('submit', getToken)
}

const removeEvents = (priceForm) => {
	priceForm.removeEventListener('submit', getToken)
}

const getToken = (evt) => {
	evt.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {

			const tokenField = document.querySelector('.g-recaptcha-token')
			tokenField.value = token
			handleSubmit(evt)

		})
	})
}

const handleSubmit = async (e) => {
	e.preventDefault()
	
	const { price_name, price_lastname, price_email, price_link, price_found } = e.target
	const Product = window.motostorm?.product || {}
	const Lang = window.motostorm?.lang
	const tokenField = document.querySelector('.g-recaptcha-token')

	try {
		const res = await axios.post(ENDPOINT, {
			data: {
				...Product,
				Lang,
				name: price_name.value,
				lastName: price_lastname.value,
				link: price_link.value,
				found: price_found.value,
				email: price_email.value,
				token: tokenField.value
			},
		})
		// display toast notification (remove this line if you prefer to display the response from the service)
		success(t('price-comparison-success'))
		// update form content (remove this line if the success notification is enough)
		//updateContent(res.data, lightboxInstance, bindEvents, removeEvents)
		// and/or automatically close the lightbox
		lightboxInstance.close()
	} catch (err) {
		console.error(`${err.name}: ${err.message}`)
		error(t('price-comparison-error'))
	}
}

const init = () => {
	// bind events before the lightbox is removed from DOM
	if (targetBtn && lightbox) {
		bindEvents(priceForm)
		lightboxInstance = createLightbox(targetBtn, targetClass)
	}
}

init()